export { SidebarNotes, default, type SidebarNotesProps } from './SidebarNotes';
